export default __webpack_public_path__ + "static/media/ilus4.f9d7d132.jpeg";